// By Oumi theme — reserved for future interactivity (e.g. quick variant swaps,
// mobile nav toggle). Currently empty because the cart and newsletter forms
// are handled natively by Shopify's Liquid forms in the sections.

// Product funnel — sticky checkout bar, appears after scrolling past the hero
document.addEventListener('DOMContentLoaded', function () {
  var sticky = document.querySelector('[data-pf-sticky]');
  var hero = document.querySelector('.pf-hero');
  if (sticky && hero) {
    window.addEventListener('scroll', function () {
      var heroBottom = hero.getBoundingClientRect().bottom;
      if (heroBottom < 0) {
        sticky.classList.add('pf-visible');
      } else {
        sticky.classList.remove('pf-visible');
      }
    });
  }
});

// Announcement bar — cycles through messages if there's more than one
document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('[data-announcement-bar]');
  if (bar) {
    var messages = bar.querySelectorAll('[data-announcement-message]');
    if (messages.length > 1) {
      var idx = 0;
      setInterval(function () {
        messages[idx].style.display = 'none';
        idx = (idx + 1) % messages.length;
        messages[idx].style.display = 'block';
      }, 4000);
    }
  }

  // Hero carousel — prev/next arrows, dots, and auto-rotate
  var carousel = document.querySelector('[data-hero-carousel]');
  if (carousel) {
    var slides = carousel.querySelectorAll('[data-hero-slide]');
    var dots = carousel.querySelectorAll('[data-hero-dot]');
    var current = 0;

    function showSlide(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      current = index;
    }

    var prevBtn = carousel.querySelector('[data-hero-prev]');
    var nextBtn = carousel.querySelector('[data-hero-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        showSlide((current - 1 + slides.length) % slides.length);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        showSlide((current + 1) % slides.length);
      });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { showSlide(i); });
    });

    if (slides.length > 1) {
      setInterval(function () {
        showSlide((current + 1) % slides.length);
      }, 6000);
    }
  }
});

// Hamburger drawer menu
document.addEventListener('DOMContentLoaded', function () {
  var hamburger = document.querySelector('[data-hamburger]');
  var drawer = document.querySelector('[data-menu-drawer]');
  var overlay = document.querySelector('[data-menu-overlay]');
  var closeBtn = document.querySelector('[data-menu-close]');

  function openMenu() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  // Sluit menu als er een link aangeklikt wordt
  if (drawer) {
    drawer.querySelectorAll('.menu-drawer-link').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }
});
